import React, { Component } from 'react'
import ReworkReasonModalUI from './ReworkReasonModalUI'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class ReworkReasonModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      remarks: '',
      submitting: false
    }
  }

  onRemarksChange = (value) => {
    this.setState({ remarks: value })
  }

  onSubmitClick = () => {
    if (this.state.submitting) return

    this.setState({ submitting: true })

    const { context, loan, apiEndpoint, onSuccess, onCancelClick } = this.props
    const loanId = loan.loanId
    const remarks = this.state.remarks.trim()

    const url = remarks
      ? `${apiEndpoint}?remarks=${encodeURIComponent(remarks)}`
      : apiEndpoint

    RestApiUtils.post(
      context,
      url,
      (response) => {
        this.setState({ submitting: false })

        if (response.errorList && response.errorList.length > 0) {
          // Handle errors - you might want to show them
          console.error('Rework submission error:', response.errorList)
          // Optionally close or show error
          if (onCancelClick) onCancelClick()
        } else {
          // Success
          if (onSuccess) {
            onSuccess()
          } else if (onCancelClick) {
            onCancelClick()
          }
        }
      },
      null,
      null
    )
  }

  render() {
    const { remarks, submitting } = this.state
    const { title, onCancelClick } = this.props

    return (
      <ReworkReasonModalUI
        title={title}
        remarks={remarks}
        onRemarksChange={this.onRemarksChange}
        onSubmitClick={this.onSubmitClick}
        onCancelClick={onCancelClick}
        submitting={submitting}
      />
    )
  }
}

export default ReworkReasonModalSF